/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Waypoint } from "react-waypoint";

import { SearchResultsPageEvent, useSearchResultsPageDataSelector } from ".";
import { LoadingStatus } from "../../../rootReducer/actions";
import AppGutter from "../../Common/AppGutter";
import SecondHeader from "../../Common/SecondHeader";
import ErrorPage from "../ErrorPage";
import * as configData from "../../../config.json";

/**Filters phrases shorter than 20 characters which only includes letters and spaces **/
const reg = /^[a-zA-Z0-9 ]{1,20}$/;

function validateSearchKeyword(keyword: string | undefined | null) {
  if (keyword) {
    if (!reg.exec(keyword)) {
      return false;
    } else {
      return true;
    }
  }
  return true;
}

export default function SearchResultsPage() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageData = useSearchResultsPageDataSelector();
  let parameters: {
    keyword?: string;
  } = useParams();

  useLayoutEffect(() => {
    setCurrentPage(1);
    if (validateSearchKeyword(parameters.keyword)) {
      if (parameters.keyword) {
        dispatch({
          type: SearchResultsPageEvent.GET_PAGE_DATA,
          payload: {
            body: {
              search: parameters.keyword,
            },
            pageNo: currentPage,
            pageSize: configData.APPS_PER_PAGE,
          },
        });
      } else {
        dispatch({
          type: SearchResultsPageEvent.GET_PAGE_DATA,
          payload: {
            body: {
              search: "",
            },
            pageNo: currentPage,
            pageSize: configData.APPS_PER_PAGE,
          },
        });
      }
    }

    return () => {
      // cleanup
      dispatch({
        type: SearchResultsPageEvent.RESET,
      });
    };
  }, [parameters.keyword]);

  const onCallBack = (args: Waypoint.CallbackArgs) => {
    if (currentPage < pageData?.totalPages) {
      if (parameters.keyword) {
        dispatch({
          type: SearchResultsPageEvent.GET_PAGE_DATA,
          payload: {
            body: {
              search: parameters.keyword,
            },
            pageNo: currentPage + 1,
            pageSize: configData.APPS_PER_PAGE,
          },
        });
      } else {
        dispatch({
          type: SearchResultsPageEvent.GET_PAGE_DATA,
          payload: {
            body: {
              search: "",
            },
            pageNo: currentPage + 1,
            pageSize: configData.APPS_PER_PAGE,
          },
        });
      }
      setCurrentPage(currentPage + 1);
    }
    return;
  };

  return (
    <>
      <SecondHeader key="normal" />
      {pageData.loadingStatus === LoadingStatus.LOADING_ERROR ? (
        <ErrorPage />
      ) : (
        <div className="container">
          <AppGutter
            pageData={pageData}
            keyword={parameters.keyword}
            parameters={parameters}
          />
          {pageData.apps.length !== 0 &&
            pageData.apps.length < pageData.totalElements && (
              <Waypoint onEnter={onCallBack} scrollableAncestor={window} />
            )}
        </div>
      )}
    </>
  );
}
